import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

/**
 * Export grouped employees to PDF
 * @param {Array} office - office employees
 * @param {Array} support - support employees
 * @param {Array} contract - contract employees
 * @param {Array} columns - columns same as excelColumns
 * @param {string} fileName - PDF file name
 */
export const exportGroupedEmployeesPDF = (
  office = [],
  support = [],
  contract = [],
  columns = [],
  fileName = "Employees.pdf"
) => {
  const doc = new jsPDF("landscape");

  // Title
  doc.setFontSize(14);
  doc.text("All Employees", 14, 15);

  // Helper to create rows for autoTable
  const prepareRows = (list) =>
    list.map((row, idx) =>
      columns.map((col) => {
        if (col.key === "sn") return idx + 1; // S.No resets per group
        if (typeof col.value === "function") return col.value(row) || "";
        if (col.type === "date") return row[col.key] ? new Date(row[col.key]).toLocaleDateString("en-IN") : "";
        return row[col.key] ?? "";
      })
    );

  // Define table columns
  const tableHeaders = columns.map((col) => col.header);

  // Starting position
  let startY = 20;

  // Helper to add a group
  const addGroup = (title, list, color = [200, 200, 200]) => {
    if (!list || list.length === 0) return;

    // Add a small space before group
    startY += 5;

    // Group header row
    autoTable(doc, {
      startY,
      head: [[`${title} (${list.length})`]],
      body: [],
      theme: "plain",
      headStyles: {
        fillColor: color,
        fontStyle: "bold",
        halign: "center",
        fontSize: 12
      },
      margin: { left: 14, right: 14 }
    });

    startY = doc.lastAutoTable.finalY + 2;

    // Add group data
    autoTable(doc, {
      startY,
      head: [tableHeaders],
      body: prepareRows(list),
      styles: {
        fontSize: 9,
        cellPadding: 3,
        textColor: [0, 0, 0]
      },
      headStyles: {
        fillColor: [79, 129, 189],
        textColor: 255,
        fontStyle: "bold"
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      },
      margin: { left: 14, right: 14 }
    });

    startY = doc.lastAutoTable.finalY + 2;
  };

  // Add all groups with distinct colors
  addGroup("Office Employees", office, [173, 216, 230]); // light blue
  addGroup("Support Employees", support, [255, 230, 153]); // light yellow
  addGroup("Contract Employees", contract, [183, 222, 232]); // cyan

  // Save PDF
  doc.save(fileName);
};
